import { useState } from 'react';
import TextField from '@mui/material/TextField';
import EntityDetailPopup from '../../utility/EntityDetailPopup';
import { popupClasses } from '../../utility/constants';

const driverKeys = ['driver_name', 'driver_license_number', 'employee_id'];

export default function DriverEntryPopup(props) {
  const { handleDriverSave, handleSetSelDriver, selDriver, farmName, currDarkThemeClass = '', ...otherProps } = props;

  const [loading, setLoading] = useState(false);

  const driverEntryTextFieldProps = ({ prop, inputProps = {}, otherTextProps = {} }) => ({
    autoComplete: 'off',
    className: `${popupClasses?.strainEntry?.textField} ${currDarkThemeClass}`,
    disabled: !otherProps?.toShowSave || loading,
    fullWidth: true,
    inputProps,
    label: ' ',
    onChange: ({ target: { value } }) => handleSetSelDriver(prop, value),
    required: true,
    readOnly: false,
    value: selDriver?.[prop] ?? '',
    ...otherTextProps,
  });

  const handleDriverEntrySave = async () => {
    if (driverKeys.some(key => !selDriver?.[key])) {
      return;
    }

    setLoading(true);

    let res = { success: false };

    try {
      res = await handleDriverSave(selDriver);
    } catch (error) {
      console.error('Error saving driver:', error);
    } finally {
      setLoading(false);
    }

    if (res?.success) {
      otherProps?.onClose?.();
    }
  };

  const entityDetailProps = {
    currDarkThemeClass,
    loading,
    headContentText: selDriver?.id ? `Edit Driver: ${selDriver?.driver_name}` : 'Add New Driver',
    onSaveClick: handleDriverEntrySave,
    ...otherProps,
  };

  const farmNameProps = {
    otherTextProps: {
      label: 'Farm',
      disabled: true,
    },
    prop: 'farmName',
    inputProps: {
      readOnly: true,
    },
  };

  const driverNameProps = {
    otherTextProps: {
      autoFocus: true,
      label: 'Driver Name',
    },
    prop: 'driver_name',
  };

  const driverLicenseNumberProps = {
    otherTextProps: {
      label: 'Driver License Number',
    },
    prop: 'driver_license_number',
  };

  const employeeIdProps = {
    otherTextProps: {
      label: 'Employee ID',
    },
    prop: 'employee_id',
  };

  return (
    <EntityDetailPopup {...entityDetailProps}>
      {farmName && <TextField {...driverEntryTextFieldProps(farmNameProps)} value={farmName} disabled />}
      <TextField {...driverEntryTextFieldProps(driverNameProps)} />
      <TextField {...driverEntryTextFieldProps(driverLicenseNumberProps)} />
      <TextField {...driverEntryTextFieldProps(employeeIdProps)} />
    </EntityDetailPopup>
  );
}
